module.exports = __webpack_public_path__ + "static/media/team-icon.73ec40fb.svg";